import Iframepopup from './code/Scripts/components/Iframepopup.vue';

export default {
  components: {
    Iframepopup,
  },
};
